export const COLLECTION_HERO_COVER_SIZES = '(max-width: 1023px) 88px, 312px'
